import { Key } from "../constants/enums";
import { defaultFilterValues } from "../constants/lists";
import type { AppliedFilters } from "../constants/config/filter";
import {
  serializeFiltersToQueryParams,
  setPageInQueryParams,
  setTeacherIdsInQueryParams,
  GROUP_NAME_PARAM,
  LESSON_NAME_PARAM,
  RANGE_PARAM,
} from "./queryParams";
import { DEFAULT_RANGE_TOKEN } from "./dateRange";

export const ANALYTICS_PATH = "/analytics";

type GroupLinkOptions = {
  classroomId: number;
  classroomName?: string | null;
  teacherUserId?: number | null;
  range?: string | null;
};

type LessonLinkOptions = GroupLinkOptions & {
  lessonId: number;
  lessonName?: string | null;
};

const buildHref = ({
  classroomId,
  classroomName,
  lessonId,
  lessonName,
  teacherUserId,
  range,
}: GroupLinkOptions & {
  lessonId?: number;
  lessonName?: string | null;
}): string => {
  const filters: AppliedFilters = {
    ...defaultFilterValues,
    [Key.CLASSROOM_NAME]: [String(classroomId)],
    [Key.LESSON_NAME]: lessonId === undefined ? [] : [String(lessonId)],
    [Key.LAST_LEARNED]: undefined,
  };

  let params = serializeFiltersToQueryParams(filters, new URLSearchParams());
  params = setPageInQueryParams(1, params);
  if (teacherUserId != null) {
    params = setTeacherIdsInQueryParams([teacherUserId], params);
  }
  if (range) params.set(RANGE_PARAM, range);

  if (classroomName) params.set(GROUP_NAME_PARAM, classroomName);
  if (lessonId !== undefined && lessonName) {
    params.set(LESSON_NAME_PARAM, lessonName);
  }

  return `${ANALYTICS_PATH}?${params.toString()}`;
};

export const buildGroupAnalyticsHref = (options: GroupLinkOptions): string =>
  buildHref({ range: DEFAULT_RANGE_TOKEN, ...options });

export const buildLessonAnalyticsHref = (options: LessonLinkOptions): string =>
  buildHref({ range: null, ...options });
